<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="pa-2 rounded elevation-1 bg-white">
                        <SportipsButton backButton chevronLeft>Retour</SportipsButton>
                        <div class="text-h5 font-weight-bold my-2">Les préinscriptions</div>
                        <div>Cette interface vous permet de consulter les préinscriptions de {{
                            mainStore.module.nom }}.</div>
                        <PreInscriptionsList mode="admin"></PreInscriptionsList>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import PreInscriptionsList from "@/components/Administration/PreInscrinscriptions/PreInscriptionsList.vue";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    components: { PreInscriptionsList },
    computed: {
        ...mapStores(useMainStore),
    },
}
</script>

<style lang="scss" scoped></style>